import {
  getCopyWithContentTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import { numerify } from '@/filters'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getCopyWithContentTableColumn({
        field: 'id',
        title: i18n.t('scope.text_451'),
      }),
      {
        field: 'type',
        title: i18n.t('scope.text_827'),
        minWidth: 70,
        formatter: ({ cellValue }) => {
          const obj = {
            redeem: i18n.t('scope.text_935'),
            campaign: i18n.t('scope.text_936'),
            giftcard: i18n.t('scope.text_937'),
            compensation: i18n.t('scope.text_938'),
          }
          return obj[cellValue]
        },
      },
      {
        field: 'amount',
        title: i18n.t('scope.text_647'),
        minWidth: 100,
        formatter: ({ cellValue }) => {
          return numerify(cellValue, '0,0.00')
        },
      },
      {
        field: 'currency',
        title: i18n.t('scope.text_442'),
        minWidth: 70,
      },
      {
        title: i18n.t('scope.text_512'),
        field: 'notes',
        minWidth: 120,
      },
      getTimeTableColumn({ title: i18n.t('scope.text_828'), field: 'valid_since' }),
      getTimeTableColumn({ title: i18n.t('scope.text_829'), field: 'valid_until' }),
      {
        title: i18n.t('scope.text_426'),
        field: 'status',
        minWidth: 70,
        formatter: ({ cellValue }) => {
          const obj = {
            valid: i18n.t('scope.text_799'),
            redeemed: i18n.t('scope.text_939'),
            cancelled: i18n.t('scope.text_523'),
          }
          return obj[cellValue]
        },
      },
    ]
  },
}
